var map = {
	"./978-83-961590-4-5.jpg": 8063,
	"./978-83-961673-0-9.jpg": 8511,
	"./978-83-969323-8-9.jpg": 1715,
	"./978-83-969323-9-6.jpg": 5844,
	"./Angielskie czasowniki modalne nowatorską i oryginalną metodą.jpg": 3095,
	"./Angielskie przedimki - Super Test.jpg": 539,
	"./Angielskie przedimki nowatorską i oryginalną metodą.jpg": 7366,
	"./Angielskie przyimki nowatorską i oryginalną metodą.jpg": 4458,
	"./Angielskie przyimki oryginalną metodą. Część 1.jpg": 34,
	"./Angielskie przyimki oryginalną metodą.jpg": 6869,
	"./Angielskie przyimki. Super test.jpg": 8969,
	"./Angielskie przyimki. Ćwiczenia.jpg": 1854,
	"./I like to watch TV czy I like watching TV. Angielski bezokolicznik i rzeczownik odsłowny.jpg": 1143,
	"./ISBN 978-83-954625-5-9.jpg": 6209,
	"./ISBN 978-83-954625-6-6.jpg": 7715,
	"./ISBN 978-83-954625-7-3.jpg": 8377,
	"./ISBN 978-83-954625-8-0.jpg": 4244,
	"./ISBN 978-83-954625-9-7.jpg": 7679,
	"./ISBN 978-83-961590-0-7.jpg": 8585,
	"./ISBN 978-83-961590-3-8.jpg": 130,
	"./ISBN 978-83-961590-4-5.jpg": 5667,
	"./ISBN 978-83-961590-5-2.jpg": 1757,
	"./ISBN 978-83-961590-7-6.jpg": 9316,
	"./ISBN 978-83-961590-9-0.jpg": 2220,
	"./ISBN 978-83-961593-0-4.jpg": 2112,
	"./ISBN 978-83-961593-1-1.jpg": 8214,
	"./ISBN 978-83-961593-2-8.jpg": 257,
	"./ISBN 978-83-961593-3-5.jpg": 4123,
	"./ISBN 978-83-961593-4-2.jpg": 7367,
	"./ISBN 978-83-961593-5-9.jpg": 9993,
	"./ISBN 978-83-961593-6-6.jpg": 7647,
	"./ISBN 978-83-961593-7-3.jpg": 9050,
	"./ISBN 978-83-961593-8-0.jpg": 2541,
	"./ISBN 978-83-961593-9-7.jpg": 5334,
	"./ISBN 978-83-961645-0-6.jpg": 865,
	"./ISBN 978-83-961645-1-3.jpg": 714,
	"./ISBN 978-83-961645-2-0.jpg": 6604,
	"./ISBN 978-83-961645-3-7.jpg": 412,
	"./ISBN 978-83-961645-4-4.jpg": 2578,
	"./ISBN 978-83-961645-5-1.jpg": 363,
	"./ISBN 978-83-961645-6-8.jpg": 8231,
	"./ISBN 978-83-961645-7-5.jpg": 5711,
	"./ISBN 978-83-961673-1-6.jpg": 7040,
	"./ISBN 978-83-961673-2-3.jpg": 6671,
	"./ISBN 978-83-961673-3-0.jpg": 2854,
	"./ISBN 978-83-961673-4-7.jpg": 712,
	"./ISBN 978-83-961673-5-4.jpg": 7635,
	"./ISBN 978-83-961673-6-1.jpg": 1196,
	"./ISBN 978-83-961673-7-8.jpg": 1947,
	"./ISBN 978-83-961673-8-5.jpg": 1104,
	"./ISBN 978-83-961673-9-2.jpg": 6976,
	"./ISBN 978-83-968474-0-9.jpg": 8265,
	"./ISBN 978-83-968474-1-6.jpg": 1306,
	"./ISBN 978-83-968474-2-3.jpg": 3826,
	"./ISBN 978-83-968474-6-1.jpg": 8085,
	"./ISBN 978-83-968474-7-8.jpg": 5032,
	"./ISBN 978-83-969323-5-8.jpg": 1307,
	"./logo.jpg": 5096,
	"./okladka13.jpg": 4159,
	"./okladka14.jpg": 179,
	"./okladka15.jpg": 2214,
	"./ot.jpg": 3109,
	"./wersja-1A.jpg": 3925,
	"./wersja-1B.jpg": 1093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;